






















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { Product } from '~/modules/catalog/product/types';
import { useUiState } from '~/composables';
import SvgImage from '~/components/General/SvgImage.vue';
import LinkWithArrow from '~/components/General/LinkWithArrow.vue';
import {
  getProductQuickShip,
  getProductShippingTimeFrame,
} from '~/modules/catalog/product/getters/productGetters';

export default defineComponent({
  components: {
    SvgImage,
    LinkWithArrow,
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null,
    },
  },
  setup() {
    const { toggleShippingModal } = useUiState();

    return {
      getProductQuickShip,
      getProductShippingTimeFrame,
      toggleShippingModal,
    };
  },
});
